export default [
  {
    title: 'Дизайнер интерфейсов',
    description: 'Дизайнер интерфейсов делает цифровые продукты удобными, создавая на сайте понятную навигацию. Такому специалисту приходится не только обладать художественным вкусом и основами программирования, но и иметь навыки психолога, чтобы предугадывать действия пользователей.',
    stories_url: 'https://itday.hb.bizmrg.com/UI.png',
    img: require('@/assets/test/it_it_day-5.svg'),
    shareImg: 'photo-174311295_457241414',
    small: 'Удобство – это про меня! Я одновременно художник, программист и психолог.',
    img_id: 'UI',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: 1,
    local_x: 1,
    local_y: -1,
  },
  {
    title: 'Специалист по видеомаркетингу',
    description: 'Видеомаркетинг — перспективное направление и тренд ближайших лет из-за роста привлекательности видеоформата. Специалист по видеомаркетингу — это человек, который сам разбирается в съёмке видео, а ещё может разработать стратегию его продвижения в соцсетях и на других ресурсах.',
    stories_url: 'https://itday.hb.bizmrg.com/Video.png',
    img: require('@/assets/test/it_it_day-8.svg'),
    shareImg: 'photo-174311295_457241402',
    small: 'Я часто залипаю на крутые видосы, и, кажется, пора начинать снимать свои!',
    img_id: 'VIDEO',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: -1,
    local_x: 1,
    local_y: 1,
  },
  {
    title: 'SMM-менеджер',
    description: 'Сейчас SMM-менеджеру недостаточно просто писать посты и подбирать к ним картинки. Такому специалисту нужно разбираться\n    в рекламе и продвижении, уметь рассчитывать бюджет, работать с дизайнерами и копирайтерами, чтобы успешно продвигать в социальных сетях компанию, бренд или продукт.',
    stories_url: 'https://itday.hb.bizmrg.com/SMM.png',
    small: 'Помогу продвинуть любой продукт в социальных сетях.',
    img: require('@/assets/test/it_it_day-16.svg'),
    shareImg: 'photo-174311295_457241410',
    img_id: 'SMM',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: -1,
    local_x: 1,
    local_y: -1,
  },
  {
    title: 'Таргетолог',
    description: 'Таргетолог настраивает рекламную кампанию в соцсетях так, чтобы она показывалась не всем подряд, а только определенным людям — целевой аудитории, которой это будет потенциально интересно. Современные инструменты соцсетей позволяет достучаться до самых нужных пользователей.',
    stories_url: 'https://itday.hb.bizmrg.com/target.png',
    small: 'С помощью социальных сетей достучусь до ваших сердечек.',
    img: require('@/assets/test/it_it_day-11.svg'),
    shareImg: 'photo-174311295_457241405',
    img_id: 'TARGET',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: 1,
    local_x: -1,
    local_y: -1,
  },
  {
    title: 'Комьюнити-менеджер',
    description: 'Задачи комьюнити-менеджера выходят далеко за пределы простого администрирования сообществ в соцсетях. Такой человек оказывает поддержку его участникам и следит за их настроением, создает для них активности и мероприятия. Но несмотря на весь спектр его обязанностей, всё же самое главное в его работе – общение с людьми.',
    stories_url: 'https://itday.hb.bizmrg.com/Community.png',
    small: 'Своей поддержкой, активностью и чуткостью расположу любую аудиторию.',
    img: require('@/assets/test/it_it_day-6.svg'),
    shareImg: 'photo-174311295_457241415',
    img_id: 'COMMUNITY',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: -1,
    local_x: -1,
    local_y: -1,
  },
  {
    title: 'Backend-разработчик',
    description: 'Бэкендеры — это программисты, которые разрабатывают всё то, что не видит и напрямую не трогает пользователь. Однако именно этот специалист делает с помощью программного кода так, чтобы человек получал от ресурса тот результат, который запрашивает – например, когда набирает поисковый запрос.',
    stories_url: 'https://itday.hb.bizmrg.com/Backend.png',
    small: 'Именно я буду делаю так, чтобы наш продукт работал без сбоев!',
    img: require('@/assets/test/it_it_day-7.svg'),
    shareImg: 'photo-174311295_457241401',
    img_id: 'BACKEND',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: 1,
    local_x: -1,
    local_y: 1,
  },
  {
    title: 'Frontend-разработчик',
    description: 'Работа фронтендера – это всё, что видит пользователь, открывая интерфейс страницы. Код, который создаёт фронтенд-разработчик, описывает цвета, вёрстку, шрифты, расположение графических элементов. Основные необходимые знания для такого специалиста – это технологии HTML, CSS и JavaScript.',
    stories_url: 'https://itday.hb.bizmrg.com/Frontend.png',
    small: 'Я буду создавать лицо сайтов. Такой фронтендер нужен каждой компании!',
    img: require('@/assets/test/it_it_day-9.svg'),
    shareImg: 'photo-174311295_457241403',
    img_id: 'FRONT',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: 1,
    local_x: 1,
    local_y: 1,
  },
  {
    title: 'Мобильный разработчик',
    description: 'Мир уже невозможно представить без мобильных устройств, поэтому профессия мобильного разработчика так востребована. Такому специалисту приходится быть одновременно дизайнером, верстальщиком и программистом, чтобы создавать приложения для планшетов и смартфонов.',
    stories_url: 'https://itday.hb.bizmrg.com/mobile.png',
    small: 'Смартфоны грустят без моих разработок!',
    img: require('@/assets/test/it_it_day-19.svg'),
    shareImg: 'photo-174311295_457241413',
    img_id: 'MOBILE',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: 1,
    local_x: 1,
    local_y: -1,
  },
  {
    title: 'QA-специалист',
    description: 'Одну из главных ролей в совершенствовании любого сервиса играют специалисты по обеспечению качества, то есть QA-специалисты. Они тщательно тестируют продукт на разных этапах его разработки для того, чтобы до пользователей дошёл качественный результат без ошибок и багов.',
    stories_url: 'https://itday.hb.bizmrg.com/QA.png',
    small: 'Внимательность – моё второе имя! Ни один баг от меня не убежит.',
    img: require('@/assets/test/it_it_day-14.svg'),
    shareImg: 'photo-174311295_457241408',
    img_id: 'QA',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: -1,
    local_x: 1,
    local_y: 1,
  },
  {
    title: 'ML-инженер',
    description: 'Главная задача ML-инженера – научить программу анализировать данные и делать на их основе логические выводы. Кажется, что эта профессия схожа с Data Scientist, однако ML-инженер в своей работе больше сталкивается с классическим программированием, чем его коллега.',
    stories_url: 'https://itday.hb.bizmrg.com/ML.png',
    small: 'За меня ещё поборются самые крутые компании!',
    img: require('@/assets/test/it_it_day-4.svg'),
    shareImg: 'photo-174311295_457241416',
    img_id: 'ML',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: 1,
    local_x: -1,
    local_y: -1,
  },
  {
    title: 'Data Scientist',
    description: 'В своей работе Data Scientist анализирует огромные объёмы информации (большие данные), чтобы делать на их основе некоторые прогнозы. Например, именно благодаря такому специалисту лента новостей становится «умной» и предлагает пользователю потенциально интересный ему контент.',
    stories_url: 'https://itday.hb.bizmrg.com/DS.png',
    small: 'Выведу бизнес на новый уровень с помощью науки о данных.',
    img: require('@/assets/test/it_it_day-10.svg'),
    shareImg: 'photo-174311295_457241404',
    img_id: 'DS',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: 1,
    local_x: -1,
    local_y: 1,
  },
  {
    title: 'Разработчик игр',
    description: 'Разработка игр неотделима от любви к ним: чтобы прийти в эту профессию, без увлечениями играми и геймерского опыта не обойтись. Но также разработчик игр должен быть по определению хорошим программистом и знать математику, которой в геймдеве немало.',
    stories_url: 'https://itday.hb.bizmrg.com/Game.png',
    small: 'Вот говорила мне мама, что игры — это несерьёзно, а я сделаю их своей профессией!',
    img: require('@/assets/test/it_it_day-18.svg'),
    shareImg: 'album-174311295_275640187',
    img_id: 'GAME',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: 1,
    local_x: 1,
    local_y: 1,
  },
  {
    title: 'Специалист технической поддержки',
    description: 'Специалист технической поддержки – это тот, кто первым приходит на помощь пользователям при любых возникающих вопросах. Вопросы могут быть самыми разными – от самых серьезных до абсурдных – однако такой специалист должен с пониманием отнестись к проблеме и как можно скорее помочь решить её.',
    stories_url: 'https://itday.hb.bizmrg.com/target.png',
    small: 'Перед вами самый спокойный и отзывчивый человек. Решать проблемы – это ко мне.',
    img: require('@/assets/test/it_it_day-13.svg'),
    shareImg: 'photo-174311295_457241407',
    img_id: 'SUPPORT',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: -1,
    local_x: 1,
    local_y: -1,
  },
  {
    title: 'Модератор контента',
    description: 'Модераторы контента – те загадочные герои, которые круглосуточно и без выходных обрабатывают жалобы пользователей, удаляют запрещённый контент и блокируют нарушителей, делая социальные сети безопасным и комфортным местом.',
    stories_url: 'https://itday.hb.bizmrg.com/Moderator.png',
    small: 'Комфорт и безопасность в соцсетях – моё призвание.',
    img: require('@/assets/test/it_it_day-12.svg'),
    shareImg: 'photo-174311295_457241406',
    img_id: 'MODERATOR',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: -1,
    local_x: -1,
    local_y: -1,
  },
  {
    title: 'UX-исследователь',
    description: 'В своей работе UX-исследователь изучает поведение пользователей: узнаёт, чем они живут и с какими сложностями сталкиваются. На основании этих знаний он помогает создать продукт, который отвечает потребностям аудитории, а также помогает бизнесу избежать непродуманных решений и лишних затрат.',
    stories_url: 'https://itday.hb.bizmrg.com/UX.png',
    small: 'Я знаю, как сделать любой продукт понятным и удобным для пользователей!',
    img: require('@/assets/test/it_it_day-17.svg'),
    shareImg: 'photo-174311295_457241411',
    img_id: 'UX',
    post_url: '123',
    post_text: '123',
    global_x: 1,
    global_y: -1,
    local_x: -1,
    local_y: 1,
  },
  {
    title: 'Продакт-менеджер',
    description: 'Продакт-менеджер работает на стыке бизнеса, маркетинга и программирования. Он отвечает за то, чтобы его команда сделала высококлассный продукт, и контролирует работу над ним на всех этапах: от анализа рынка и создания первого прототипа до продаж.',
    stories_url: 'https://itday.hb.bizmrg.com/Product.png',
    small: 'Моя будущая команда будет выпускать только крутые продукты, потому что я буду следить за их качеством!',
    img: require('@/assets/test/it_it_day-15.svg'),
    shareImg: 'photo-174311295_457241409',
    img_id: 'PRODUCT',
    post_url: '123',
    post_text: '123',
    global_x: -1,
    global_y: -1,
    local_x: -1,
    local_y: 1,
  },
]
